module.exports = __webpack_public_path__ + "img/youshi4.c4f16971.svg";